import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { filterUndefineds } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetUserContentRequestBody,
  IApiGetUserContentResponseBody,
} from '../UserContentApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseUserContentQueryValues = {
  appId: string;
  body?: IApiGetUserContentRequestBody;
};

export const userGeneratedContentQueryKeyFactory: IQueryKeyFactory<
  IUseUserContentQueryValues
> = (values) =>
  values &&
  filterUndefineds(['userGeneratedContent', values.appId, values.body]);

export const useUserContentQuery = (
  values?: IUseUserContentQueryValues,
  options?: UseQueryOptions<IApiGetUserContentResponseBody, ApiError>,
): UseQueryResult<IApiGetUserContentResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: userGeneratedContentQueryKeyFactory(values),
    queryFn: values
      ? () => api.userContent.getAll(values.appId, values.body)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
